function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.534 1.016a1.066 1.066 0 10-1.507 1.507l7.158 7.158a1.598 1.598 0 002.26 0l7.159-7.158a1.066 1.066 0 10-1.507-1.507l-6.46 6.46a.455.455 0 01-.643 0l-6.46-6.46z",
  fillRule: "nonzero"
});

function SvgDownArrowBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    viewBox: "0 0 18 11",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgDownArrowBold;